import React from "react";
import DepartementPage from "./DepartementPage";

const AMOSeineEtMarne77 = () => {
  return <DepartementPage dept="seine-et-marne" />;
};

export default AMOSeineEtMarne77;
